import styles from './Divider.module.scss'

interface DividerProps {
  className?: string
}
const Divider = ({ className }: DividerProps) => {
  return <hr className={`${styles.divider} ${className ?? ''}`} data-testid="divider" />
}

export default Divider
